export default __webpack_public_path__ + "static/media/whiteEdit.d04cf33f.svg";